const initialState = {
    selectedAttachment: null
};

const selectedAttachmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_ATTACHMENT': {
            return {
                ...state,
                selectedAttachment: action.payload
            }
        }
        default: {
            return state;
        }
    }
};

export default selectedAttachmentReducer;
